// Explicit preview fixtures. These are synthetic and are never live account data.
import { ART_BASE as ASSET } from '../assets.js';

export const FIXTURE_KIDS = [
  {
    id: 'maya',
    name: 'Maya',
    age: 9,
    avatar: `${ASSET}/avatar-kid-1.jpg`,
    litCount: 2,
    totalCount: 3,
    pendingCount: 1,
    recap: 'Maya completed Unload dishwasher · $0.75 pending approval',
  },
  {
    id: 'leo',
    name: 'Leo',
    age: 11,
    avatar: `${ASSET}/avatar-kid-2.jpg`,
    litCount: 3,
    totalCount: 4,
    pendingCount: 1,
    recap: 'Leo completed Walk Biscuit · $1.00 pending approval',
  },
  {
    id: 'finn',
    name: 'Finn',
    age: 6,
    avatar: `${ASSET}/avatar-kid-3.jpg`,
    litCount: 1,
    totalCount: 2,
    pendingCount: 1,
    recap: 'Finn completed Make your bed · $0.50 pending approval',
  },
];

export const FIXTURE_APPROVALS = {
  count: 3,
  items: [
    {
      id: 'leo-walk-biscuit',
      iconUrl: `${ASSET}/icon-dog.png`,
      iconAlt: '',
      actor: 'Leo',
      action: 'completed',
      quest: 'Walk Biscuit',
      amount: '$1.00',
      when: 'just now',
    },
  ],
};

export const FIXTURE_WEEK = {
  title: 'Week 12',
  kicker: 'chapter',
  chip: 'settles Friday · tonight',
  chipTone: 'neutral',
  value: 21,
  goal: 30,
  unit: 'lanterns lit',
  note: 'On pace — 4 more than week 11 at this point',
  payday: '3h 40m',
  paydayLabel: 'payday in',
};

export const FIXTURE_ACTIVITY = [
  {
    id: 'a1',
    tone: 'moss',
    live: true,
    time: 'just now',
    actor: 'Leo',
    action: 'completed',
    highlight: 'Walk Biscuit',
    amount: '$1.00',
    detail: 'pending approval',
  },
  {
    id: 'a2',
    tone: 'gold',
    time: '6:12 PM',
    actor: 'Maya',
    action: 'completed',
    highlight: 'Unload dishwasher',
    amount: '$0.75',
    detail: 'pending approval',
  },
  {
    id: 'a3',
    tone: 'violet',
    time: '5:48 PM',
    actor: 'Leo',
    action: 'earned the badge',
    highlight: 'Week Warrior',
    detail: '— 7 quests in a row',
  },
  {
    id: 'a4',
    tone: 'ember',
    time: '4:55 PM',
    actor: 'Maya',
    action: 'earned a streak freeze',
    detail: '— 3-day streak (freeze available)',
  },
  {
    id: 'a5',
    tone: 'gold',
    time: '4:12 PM',
    actor: 'Finn',
    action: 'completed',
    highlight: 'Make your bed',
    amount: '$0.50',
    detail: 'pending approval',
  },
  {
    id: 'a6',
    tone: 'river',
    time: 'Thu 7:02 PM',
    actor: 'David',
    action: 'accepted the family invitation',
    detail: '— added as parent',
  },
];

export const FIXTURE_PENDING = {
  total: 21.25,
  rows: [
    { id: 'maya', name: 'Maya', avatar: `${ASSET}/avatar-kid-1.jpg`, amount: 7.25 },
    { id: 'leo', name: 'Leo', avatar: `${ASSET}/avatar-kid-2.jpg`, amount: 9.5 },
    { id: 'finn', name: 'Finn', avatar: `${ASSET}/avatar-kid-3.jpg`, amount: 4.5 },
  ],
};


export const dashboardFixture = {
  parentName: 'Sara', notifications: 3, bandTitle: 'The Silva family — Friday evening (sample)',
  paydaySubtitle: 'Sample payday schedule', kids: FIXTURE_KIDS, approvals: FIXTURE_APPROVALS,
  week: FIXTURE_WEEK, activity: FIXTURE_ACTIVITY, pendingMoney: FIXTURE_PENDING,
};
